import React,{useState} from "react";
import "./Footer.scss";
import { SlSocialVkontakte } from "react-icons/sl";
import { PiTelegramLogoThin,PiEnvelopeThin,PiWhatsappLogoThin } from "react-icons/pi";


import { Link } from "react-router-dom";
const Footer = () => {
   const [copied,setCopied]=useState(false)

  
  

    function copyEmail() {
        navigator.clipboard.writeText('info@puretrip.org').then(()=>{
          setCopied(true)
          setTimeout(()=>{setCopied(false)},2000)
        })
        
        
        
      }

      
  return (
    <div className="footer-box">
      <div className="links">
        <Link to={"https://vk.com/tur_v_kitay"} target="_blank" rel="noopener noreferrer" className="social">
          <SlSocialVkontakte color="white" size="1.7rem" />
          
        </Link>
        <Link to={"https://t.me/china_tur"} target="_blank" rel="noopener noreferrer" className="social">
        <PiTelegramLogoThin color="white" size="1.7rem" />
        
        </Link>
        <div  onClick={copyEmail}  className={copied?"social copied":"social copy-email"}>
        <PiEnvelopeThin color="white" size="1.7rem"/>
        </div>
        <Link to={""} target="_blank" rel="noopener noreferrer" className="social">
        <PiWhatsappLogoThin color="white" size="1.7rem"/>

          
        </Link>
      </div> 
      <p>© Copyright 2024 / Pure Trip</p>
    </div>
  );
};

export default Footer;
